import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'nuhospitals/digilogbook', pathMatch: 'full' },
  {
    path: ':customer',
    component: PrivacyPolicyComponent,
  },
  {
    path: ':customer/:app',
    component: PrivacyPolicyComponent,
  },  
  { path: '**', redirectTo: '', pathMatch: 'full' }
]


@NgModule({
  declarations: [
    PrivacyPolicyComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    PrivacyPolicyComponent,
  ]
})
export class PrivacyPolicyModule { }
